<template>
  <ModernSelectBox
    :value="value"
    :options="options"
    style="width: 254px"
    @input="onValueChange"
  >
    <template #optionContent="{ option }">
      <span
        :class="{'user-type-select-option-customer-type': option.isCustomerType}"
      >
        <template v-if="option.isCustomerType">
          -
        </template>
        {{ option.label }}
      </span>
    </template>
  </ModernSelectBox>
</template>

<script>

import ModernSelectBox from '@/components/ModernSelectBox.vue';
import { mapGetters } from 'vuex';

const anyOption = { value: null, label: 'Any' };
export default {
  components: {
    ModernSelectBox,
  },
  name: 'UserTypeSelect',
  props: {
    value: {
      default: null,
    },
  },
  methods: {
    onValueChange(newValue) {
      this.$emit('input', newValue);
    },
  },
  computed: {
    ...mapGetters('constant', ['userTypes']),
    options() {
      if (this.userTypeIds === null) {
        return [anyOption];
      }

      const customerOptionIds = [];
      const preparedTypes = [];
      this.userTypes.forEach((item) => {
        if (item.isCustomerType) {
          customerOptionIds.push(item.id);
        }
        preparedTypes.push({
          value: [item.id],
          label: item.value,
          isCustomerType: item.isCustomerType,
        });
      });

      return [
        anyOption,
        { value: customerOptionIds, label: 'Customer' },
        ...preparedTypes,
      ];
    },
  },
};
</script>

<style lang="stylus">
.modern-select-box-container .user-type-select-option-customer-type
  padding-left 10px
</style>
